import { format } from 'date-fns';

const dateOnlyLong = (value, def = '') => {
  if (!value) {
    return def || '';
  }
  const myDate = typeof value === 'string' ? new Date(value) : value;
  return `${format(myDate, 'MMMM d, yyyy')}`;
};

export default dateOnlyLong;
